// src/components/blocks/our-principles/ExploreCurriculum.tsx
import React from 'react';

import styled from 'styled-components';

import ForwardArrow from 'stile-shared/src/components/2024/common/Included/WITBFeatureSection/ForwardArrow';
import { Link } from 'stile-shared/src/components/2024/common/Link';

interface ExploreCardProps {
  title: string;
  description: string;
  url: string;
}

const CurriculumFooter = styled.div`
  background-color: var(--stile-grey-1);
  padding: 40px 0 100px 0;
  width: 100%;
  font-family: 'Boing';
  font-size: 40px;
  font-weight: 500;
  line-height: 45px;
  word-wrap: break-word;
  .content {
    max-width: 1160px;
    width: auto !important;
  }

  @media (max-width: 768px) {
    padding: 30px;
    font-size: 26px;
    line-height: 28px;

    .content {
      margin: 0 !important;
    }
  }
`;

const ExploreHeader = styled.div`
  display: flex;
  align-items: center;
  max-width: 1160px;
  justify-content: space-between;
  color: var(--stile-grey-8);
  margin-bottom: 20px;

  @media (max-width: 768px) {
    align-items: flex-start;
  }
`;

const ExploreTitle = styled.h4`
  font-size: inherit;
  line-height: inherit;
  color: var(--stile-grey-8);
  word-wrap: break;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 26px;
    line-height: 28px;
    text-align: left;
    margin: 14px 0 8px 0;
    max-width: 250px;
  }
`;

const ExploreImage = styled.div`
  position: relative;
  top: 0;
  right: 0;
  height: 124px;
  width: 124px;

  @media (max-width: 768px) {
    height: 78px;
    width: 78px;
  }
`;
const FooterCardTitle = styled.div`
  font-family: Graphik;
  color: var(--stile-grey-8);
  max-width: 288px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  /* padding-right: 28px; */
`;

const FooterArrow = styled(ForwardArrow)`
  position: absolute;
  top: 24px;
  right: 24px;
`;

const FooterCardText = styled.p`
  margin: 8px 0 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Show only 2 lines of description */
  -webkit-box-orient: vertical;
`;

const FooterCardsGroup = styled.div`
  display: flex;
  max-width: 1160px;
  gap: 28px;
  justify-content: center;
  @media (max-width: 768px) {
    flex-wrap: wrap;
    margin-bottom: 4px;
    gap: 15px;
    a {
      width: 100%;
    }
  }
`;

const FooterCard = styled.div`
  position: relative;
  background-color: #fff;
  color: #2b2b2b;
  padding: 24px;
  height: 124px;
  border-radius: 16px;
  max-width: 368px;
  flex: 1 1 0;
  box-shadow: 0px 5px 11px rgba(0, 0, 0, 0.07), 0px 5px 11px 0px #00000012;
  font-family: Graphik;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  overflow: hidden; /* Ensure no overflow makes the card taller */
  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
  }
`;

export const ExploreCurriculum: React.FC<{
  title: string;
  exploreCardsData: ExploreCardProps[];
  image: React.ReactNode; // Accept the constructed image as a prop
}> = ({ title, exploreCardsData, image }) => (
  <CurriculumFooter>
    <div className="content">
      <ExploreHeader>
        <ExploreTitle>{title}</ExploreTitle>
        <ExploreImage>{image}</ExploreImage>
      </ExploreHeader>
      <FooterCardsGroup>
        {exploreCardsData.map((card, index) => (
          <Link url={card.url} key={index} style={{ textDecoration: 'none', color: 'inherit' }}>
            <FooterCard>
              <FooterCardTitle>{card.title}</FooterCardTitle>
              <FooterArrow />
              <FooterCardText>{card.description}</FooterCardText>
            </FooterCard>
          </Link>
        ))}
      </FooterCardsGroup>
    </div>
  </CurriculumFooter>
);
